import React from 'react';

function CopyRight({copyright}) {
    return (
        <div><span>{copyright.copyrightName} © {(new Date().getFullYear())}.</span> <span>Tous droits réservés.</span></div>
    );
}

export default CopyRight;